import React from 'react'
import { connect } from 'react-redux'
import { Grid, Card, Typography, CardContent, Table, TableBody, TableRow, TableCell, TableContainer, Avatar, Button } from '@material-ui/core'
import { makeStyles, withStyles } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Edit';
import { openUpdateProfileModal } from '../../actions/metaAction'

const useStyles = makeStyles((theme) => ({
    avatar: {
        backgroundColor: theme.palette.primary.main,
        height: '80px',
        width: '80px',
        // margin: '0 auto'
    },
    link: {
        textDecoration: 'none',
        color: theme.palette.primary.main
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'no-wrap'
    }
}));

const CustomTableCell = withStyles(theme => ({
    root: {
        width: "calc(100%/2)",
        // padding: "10px 24px",
        // display: "table-cell"
    }
}))(TableCell);


function ProfileInfo({ full_name, email, phoneNumber, photoURL, isPorfileComplete, openUpdateProfileModal }) {

    const classes = useStyles();
    React.useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    let avatarText = ""
    if (full_name) {
        avatarText = full_name.substr(0, 1)
    }
    else if (email) {
        avatarText = email.substr(0, 1)
    }
    else if (phoneNumber) {
        avatarText = phoneNumber.toString().substr(3, 5)
    }

    return (
        <Grid xs={12} sm={7} item style={{ margin: "0 auto" }}>
            <Card>
                <CardContent>
                    {!isPorfileComplete && <Typography color="error" component="p" variant="subtitle1" align="center" >Complete your profile to Place Order</Typography>}
                    <TableContainer>
                        <Table>
                            <TableBody>
                                <TableRow >
                                    <CustomTableCell aria-label="avatar" align='left'>
                                        <Avatar src={photoURL} className={classes.avatar} > {avatarText} </Avatar>
                                    </CustomTableCell>
                                    <CustomTableCell aria-label="avatar" align='left'>
                                        <div className={classes.row}>
                                            <Typography color="primary" component="p" variant="h5" noWrap >Basic Info </Typography>
                                            <Button endIcon={<EditIcon />} size="small" variant="contained" color="secondary" onClick={openUpdateProfileModal} >Update</Button>
                                        </div>
                                    </CustomTableCell>
                                </TableRow>
                                <TableRow>
                                    <CustomTableCell aria-label="name" align='left'> <strong>Name</strong> </CustomTableCell>
                                    <CustomTableCell aria-label={full_name} align='left'>

                                        <Typography color="primary" component="p" variant="body1"> {full_name}</Typography>
                                    </CustomTableCell>
                                </TableRow>
                                <TableRow>
                                    <CustomTableCell aria-label="email" align='left'> <strong>Email</strong></CustomTableCell>
                                    <CustomTableCell aria-label={email} align='left'>
                                        <Typography color="primary" component="p" variant="body1"> {email}</Typography>
                                    </CustomTableCell>
                                </TableRow>
                                <TableRow>
                                    <CustomTableCell aria-label="phone number" align='left'><strong>Phone Number</strong></CustomTableCell>
                                    <CustomTableCell aria-label={phoneNumber} align='left'>
                                        <Typography color="primary" component="p" variant="body1">{phoneNumber}  </Typography>
                                    </CustomTableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CardContent>
            </Card>
        </Grid>
    )
}

const mapStateToProps = (state) => {

    const { full_name, email, phoneNumber, phoneVerified, photoURL } = state.user.profile

    const isPorfileComplete = Boolean(full_name) && Boolean(email) && Boolean(phoneNumber) && Boolean(phoneVerified)

    return {
        full_name,
        email,
        phoneNumber,
        photoURL,
        isPorfileComplete
    }
}

export default connect(mapStateToProps, { openUpdateProfileModal })(ProfileInfo)
